// this is an autogenerated file from App/Account/Content/Tasks/New/Menu/Expanded/BoardsArchived/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Menu_Expanded_BoardsArchived($location_id: uuid!) {
  tasks_boards(
    where: {
      status: { _eq: archived }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    name
    metadata
    created_by
  }
}

`